export interface Permission {
  code: string;
  module: string;
  action: string;
  description: string;
}

export interface UserPermissions {
  [module: string]: Permission[];
}

export enum ModuleName {
  // Staff Management
  ROLE_MANAGEMENT = 'ROLE_MANAGEMENT',
  ROLE_MANAGEMENT_CHECKER = 'ROLE_MANAGEMENT_CHECKER',
  USER_MANAGEMENT = 'USER_MANAGEMENT',
  USER_MANAGEMENT_CHECKER = 'USER_MANAGEMENT_CHECKER',
  BRANCH = 'BRANCH',
  
  // Church Management
  DENOMINATION = 'DENOMINATION',
  CHURCH = 'CHURCH',
  CHURCH_PROFILE = 'CHURCH_PROFILE',
  CHURCH_ADMIN = 'CHURCH_ADMIN',
  
  // Dashboards
  DASHBOARD = 'DASHBOARD',
  OVERALL_DASHBOARD = 'OVERALL_DASHBOARD',
  BRANCH_DASHBOARD = 'BRANCH_DASHBOARD',
  CHURCH_DASHBOARD = 'CHURCH_DASHBOARD',
  
  // System
  CARITAS = 'CARITAS',
  ACCOUNT_GOVERNANCE = 'ACCOUNT_GOVERNANCE',
  CASH_GOVERNANCE = 'CASH_GOVERNANCE',
  CLERGY_CATEGORY = 'CLERGY_CATEGORY',
  CLERGY_IDENTITY = 'CLERGY_IDENTITY',
  MEMBER_TRANSFER = 'MEMBER_TRANSFER',
  MEMBER_IDENTIFIER = 'MEMBER_IDENTIFIER',
  POLL = 'POLL',
  AUDIT = 'AUDIT',
  
  // Church Admin Modules
  CHURCH_MEMBERS = 'CHURCH_MEMBERS',
  CHURCH_SETUP = 'CHURCH_SETUP',
  CHURCH_MEMBERSHIP_JOURNEY = 'CHURCH_MEMBERSHIP_JOURNEY',
  CHURCH_OFFERINGS = 'CHURCH_OFFERINGS',
  CHURCH_RESOURCES = 'CHURCH_RESOURCES',
  CHURCH_SERVICE = 'CHURCH_SERVICE',
  CHURCH_CLERGY = 'CHURCH_CLERGY',
  CHURCH_MESSAGES = 'CHURCH_MESSAGES',
  CHURCH_PROJECTS = 'CHURCH_PROJECTS',
  CHURCH_OTHER_PROJECTS = 'CHURCH_OTHER_PROJECTS',
  CHURCH_DONATIONS = 'CHURCH_DONATIONS',
  CHURCH_ENQUIRIES = 'CHURCH_ENQUIRIES',
  CHURCH_PRAYER_REQUESTS = 'CHURCH_PRAYER_REQUESTS',
  CHURCH_ANNOUNCEMENTS = 'CHURCH_ANNOUNCEMENTS',
  CHURCH_EVENTS = 'CHURCH_EVENTS',
  CHURCH_SETTINGS = 'CHURCH_SETTINGS'
}

export enum PermissionAction {
  CREATE = 'CREATE',
  UPDATE = 'UPDATE',
  VIEW = 'VIEW',
  DELETE = 'DELETE',
  ACTIVATE = 'ACTIVATE',
  DEACTIVATE = 'DEACTIVATE',
  APPROVE = 'APPROVE',
  REJECT = 'REJECT',
  ASSIGN_PERMISSIONS = 'ASSIGN_PERMISSIONS',
  ASSIGN_ROLE = 'ASSIGN_ROLE',
  REMOVE_ROLE = 'REMOVE_ROLE'
}
